<template>
<li id="nav-toggle">

        <button @click.prevent="toggleMenu" :class="{menuOpen: open}">
            <span></span>
            <span></span>
            <span></span>
        </button>
        <p>MENU</p>


        <div id="srsidebar" :class="{out:open == true}">

                    <div class="srssidebar">
                        <a href="https://soundrink.com/#/tourlist">
                            <span>EVENTS</span>
                        </a>
                    </div>

                    <div class="srssidebar">
                          <a href="https://news.soundrink.com/">
                              <span>NEWS</span>
                          </a>
                    </div>

                    <div class="srssidebar">
                         <a href="https://help.soundrink.com/">
                             <span>FAQ</span>
                         </a>
                    </div>

                    <div class="srssidebar noflex">
                            <div>
                                <a target="_blank" class="soc" href="https://www.facebook.com/soundrink">
                                    <span>
                                        <span class="fab fa-facebook-f"></span>
                                    </span>
                                </a>
                            </div>
                            <div>
                                <a target="_blank" class="soc" href="https://www.instagram.com/sound_rink/">
                             
                                        <span class="fab fa-instagram"></span>
                               
                                </a>

                            </div>
                            <div>
                                <a target="_blank" class="soc" href="https://twitter.com/soundrink">
                                    <span>
                                        <span class="fab fa-x-twitter"></span>
                                    </span>
                                </a>

                            </div>
                    </div>
                    
          
                  
       
                   
            
            </ul>
        </div>
    </li>
</template>

<script>
export default{
    name: '',
    data(){
        return {
            open: false
        }
    },
    methods: {
      toggleMenu(){
          this.open = !this.open;
      }
    }
}

</script>

<style lang="scss" scoped>
#srsidebar{
    height:calc(100% - 60px);
    width:500px;
    max-width:100%;
    right:0px;
    top:60px;
    position:fixed;
    background:rgba(158,204,58,0.8);
    width:700px;
    transform:translateX(100%);
    transition:all .3s ease-in-out;
    z-index:1000;

    &.out{
        transform:translateX(0%);
    }

    .srssidebar{
        height:25%;
        display: flex;
        align-items: center;
        justify-content: center;
        border-top: 1px solid rgba(0,0,0,0.1);
        &:hover{
            background:rgba(0,0,0,0.1);
        }
        &:nth-child(3){
            
        }
    }
    
    a{
        display:block;
        font-size: 4rem;
        width:100%;
        height:100%;
         display: flex;
        align-items: center;
        justify-content: center;
        
        letter-spacing: 10px;
        text-shadow: 0px 7px 0px rgba(0, 0, 0,.2);
        text-align:center;

        @media(max-width:1025px){
            font-size:32px;
            width:100%;
        }
        

        &:hover{
          
                text-decoration:none;
        }
    }

    .soc{
        padding-left:40px;
        padding-right:40px;
      
    }
}
</style>


// WEBPACK FOOTER //
// resources/js/components/Soundrink/soundrink-nav-menu.vue